module.exports = __webpack_public_path__ + "img/D201406_1.96fc5cfb.jpg";